import { useMemo } from 'react';

export default function InvoiceLineEditor({ lines, setLines, accounts }) {
  const totals = useMemo(() => {
    let subtotal = 0, tax = 0;
    for (const l of lines) {
      const sub = Number(l.quantity || 0) * Number(l.unitPrice || 0);
      subtotal += sub;
      tax += sub * (Number(l.taxRate || 0) / 100);
    }
    return {
      subtotal: round(subtotal),
      tax: round(tax),
      total: round(subtotal + tax),
    };
  }, [lines]);

  function setLine(i, k, v) {
    setLines((ls) => ls.map((l, j) => (i === j ? { ...l, [k]: v } : l)));
  }
  function addLine() {
    setLines((ls) => [...ls, { description: '', quantity: 1, unitPrice: 0, accountId: '', taxRate: 0 }]);
  }
  function removeLine(i) {
    setLines((ls) => ls.filter((_, j) => j !== i));
  }

  return (
    <>
      <table className="data-table je-grid">
        <thead>
          <tr>
            <th>Description</th><th style={{ width: 70 }}>Qty</th>
            <th style={{ width: 100 }}>Unit Price</th><th>Account</th>
            <th style={{ width: 70 }}>Tax %</th><th style={{ width: 100 }}>Total</th><th></th>
          </tr>
        </thead>
        <tbody>
          {lines.map((l, i) => {
            const lineTotal = round(Number(l.quantity || 0) * Number(l.unitPrice || 0));
            return (
              <tr key={i}>
                <td><input value={l.description} onChange={(e) => setLine(i, 'description', e.target.value)} required /></td>
                <td><input type="number" step="0.01" value={l.quantity} onChange={(e) => setLine(i, 'quantity', e.target.value)} /></td>
                <td><input type="number" step="0.01" value={l.unitPrice} onChange={(e) => setLine(i, 'unitPrice', e.target.value)} /></td>
                <td>
                  <select value={l.accountId} onChange={(e) => setLine(i, 'accountId', e.target.value)} required>
                    <option value="">Select…</option>
                    {accounts.map((a) => <option key={a.id} value={a.id}>{a.code} — {a.name}</option>)}
                  </select>
                </td>
                <td><input type="number" step="0.01" value={l.taxRate} onChange={(e) => setLine(i, 'taxRate', e.target.value)} /></td>
                <td className="num">{lineTotal.toFixed(2)}</td>
                <td>{lines.length > 1 && <button type="button" className="btn ghost small" onClick={() => removeLine(i)}>×</button>}</td>
              </tr>
            );
          })}
        </tbody>
        <tfoot>
          <tr>
            <td><button type="button" className="btn ghost small" onClick={addLine}>+ Add line</button></td>
            <td colSpan={4} className="num"><strong>Subtotal</strong></td>
            <td className="num"><strong>{totals.subtotal.toFixed(2)}</strong></td>
            <td></td>
          </tr>
          <tr>
            <td></td><td colSpan={4} className="num">Tax</td>
            <td className="num">{totals.tax.toFixed(2)}</td><td></td>
          </tr>
          <tr>
            <td></td><td colSpan={4} className="num"><strong>Total</strong></td>
            <td className="num"><strong>{totals.total.toFixed(2)}</strong></td><td></td>
          </tr>
        </tfoot>
      </table>
    </>
  );
}

function round(n) { return Math.round(Number(n) * 100) / 100; }
